import { useForm } from '@mantine/form'
import React, { useEffect } from 'react'
import { modals } from '@mantine/modals'
import {
    Button,
    Flex,
    LoadingOverlay,
    PasswordInput,
    Tabs,
    TextInput,
} from '@mantine/core'

import InputUserRole from '@components/inputs/quiz/InputUserRole'
import {
    IRequestChangePassword,
    IRequestUpdateProfile,
} from '@apiinterface/IAuth'
import Auth from '@api/Auth'

const FormEditMyProfile = () => {
    const profile = Auth.useGetProfile()

    const formUpdateProfile = useForm<IRequestUpdateProfile>({
        initialValues: {
            username: profile.data?.username!,
            first_name: profile.data?.first_name!,
            last_name: profile.data?.last_name!,
            email: profile.data?.email!,
        },
    })
    const formUpdatePassword = useForm<IRequestChangePassword>({
        initialValues: {
            oldpassword: '',
            confirmpassword: '',
            password: '',
        },
    })
    const updateProfile = Auth.useUpdateProfile({
        form: formUpdateProfile,
        aftersuccess: () => {
            modals.closeAll()
            profile.refetch()
        },
    })

    const updatePassword = Auth.useChangePassword({
        form: formUpdatePassword,
        aftersuccess: () => {
            modals.closeAll()
            profile.refetch()
        },
    })

    useEffect(() => {
        if (profile.isFetched === true && profile.data) {
            formUpdateProfile.setFieldValue('email', profile.data.email)
            formUpdateProfile.setFieldValue(
                'first_name',
                profile.data.first_name
            )
            formUpdateProfile.setFieldValue('last_name', profile.data.last_name)
            formUpdateProfile.setFieldValue('username', profile.data.username)
        }
        // eslint-disable-next-line
    }, [profile.isFetched])

    return (
        <Tabs defaultValue='profile'>
            <Tabs.List mb='lg'>
                <Tabs.Tab value='profile'>โปรไฟล์</Tabs.Tab>
                <Tabs.Tab value='password'>รหัสผ่าน</Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value='profile'>
                <form onSubmit={updateProfile.onSubmit}>
                    <LoadingOverlay
                        visible={updateProfile.isLoading}
                        overlayProps={{ blur: 2 }}
                    />
                    <Flex direction='column' gap='md'>
                        <TextInput
                            styles={{
                                input: {
                                    borderColor: 'var(--mantine-color-gray-2)',
                                },
                            }}
                            {...formUpdateProfile.getInputProps('first_name')}
                            label='ชื่อจริง'
                            placeholder='ชื่อจริง '
                            data-autofocus
                        />
                        <TextInput
                            styles={{
                                input: {
                                    borderColor: 'var(--mantine-color-gray-2)',
                                },
                            }}
                            {...formUpdateProfile.getInputProps('last_name')}
                            label='นามสกุล'
                            placeholder='นามสกุล '
                            data-autofocus
                        />
                        <TextInput
                            styles={{
                                input: {
                                    borderColor: 'var(--mantine-color-gray-2)',
                                },
                            }}
                            {...formUpdateProfile.getInputProps('username')}
                            label='ชื่อผู้ใช้งาน'
                            placeholder='ชื่อผู้ใช้งาน '
                            data-autofocus
                        />
                        <TextInput
                            styles={{
                                input: {
                                    borderColor: 'var(--mantine-color-gray-2)',
                                },
                            }}
                            {...formUpdateProfile.getInputProps('email')}
                            label='อีเมล'
                            placeholder='อีเมล '
                        />
                        <InputUserRole
                            styles={{
                                input: {
                                    borderColor: 'var(--mantine-color-gray-2)',
                                },
                            }}
                            disabled
                            value={String(profile.data?.role_id)}
                            label='สิทธิการใช้งาน'
                            placeholder='สิทธิการใช้งาน '
                        />

                        <Button
                            fullWidth
                            type='submit'
                            radius='10px'
                            mt='md'
                            color='#e6007e'
                        >
                            ยืนยัน
                        </Button>
                    </Flex>
                </form>
            </Tabs.Panel>

            <Tabs.Panel value='password'>
                <form onSubmit={updatePassword.onSubmit}>
                    <LoadingOverlay
                        visible={updatePassword.isLoading}
                        overlayProps={{ blur: 2 }}
                    />
                    <Flex direction='column' gap='md'>
                        <PasswordInput
                            styles={{
                                input: {
                                    borderColor: 'var(--mantine-color-gray-2)',
                                },
                            }}
                            {...formUpdatePassword.getInputProps('oldpassword')}
                            label='ยืนยันรหัสผ่านเดิม'
                            placeholder='รหัสผ่านเดิม '
                            data-autofocus
                        />
                        <PasswordInput
                            styles={{
                                input: {
                                    borderColor: 'var(--mantine-color-gray-2)',
                                },
                            }}
                            {...formUpdatePassword.getInputProps('password')}
                            label='รหัสผ่านใหม่'
                            placeholder='รหัสผ่าน '
                            data-autofocus
                        />
                        <PasswordInput
                            styles={{
                                input: {
                                    borderColor: 'var(--mantine-color-gray-2)',
                                },
                            }}
                            {...formUpdatePassword.getInputProps(
                                'confirmpassword'
                            )}
                            label='ยืนยันรหัสผ่าน'
                            placeholder='ยืนยันรหัสผ่าน '
                            data-autofocus
                        />

                        <Button
                            fullWidth
                            type='submit'
                            radius='10px'
                            mt='md'
                            color='#e6007e'
                        >
                            ยืนยัน
                        </Button>
                    </Flex>
                </form>
            </Tabs.Panel>
        </Tabs>
    )
}

export default FormEditMyProfile
